import React from 'react'
import { get } from 'lodash'

import ItemActions from './common/itemActions'
import TrendingSash from './common/trendingSash'
import { getItemAttribute } from '../../../common/utils/item'
import { BaseVideoPlayer } from '@envato/react-video'

import styles from './gridVideo.module.css'

class ItemCardGridVideo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      playState: 'PAUSE',
      hideCursor: false,
      videoPlayPromise: null,
      videoLooped: false,
      reportedEvents: []
    }

    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)

    this.handleVideoReportEvent = this.handleVideoReportEvent.bind(this)
  }

  componentWillUnmount() {
    this.discardVideoReset()
  }

  handleVideoReportEvent(playProgress) {
    if (this.playProgress === 0) {
      this.reportEvent('video_start')
    }

    if (playProgress >= 25 && playProgress < 50) {
      this.reportEvent('25_percent')
    }

    if (playProgress >= 50 && playProgress < 75) {
      this.reportEvent('50_percent')
    }

    if (playProgress >= 75) {
      this.reportEvent('75_percent')
    }

    if (playProgress + 1 >= 100) {
      this.reportEvent('video_complete')
      this.setState({
        videoLooped: true
      })
    }
  }

  hasEventReported(eventName) {
    return this.state.reportedEvents.indexOf(eventName) >= 0
  }

  reportEvent(eventName) {
    if (!this.state.videoLooped && !this.hasEventReported(eventName)) {
      const { item } = this.props
      const videoSrc = get(item, 'previews.icon_with_video_preview.video_url')

      if (this.props.reportVideoProgress) {
        this.props.reportVideoProgress(eventName, videoSrc)
        this.setState({
          reportedEvents: [eventName, ...this.state.reportedEvents]
        })
      }
    }
  }

  scheduleVideoReset() {
    this.videoResetTimeout = setTimeout(() => {
      this.setState({ playState: 'RESET' })
    }, 5000)
  }

  discardVideoReset() {
    if (this.videoResetTimeout) {
      clearTimeout(this.videoResetTimeout)
      this.videoResetTimeout = null
    }
  }

  pauseVideo() {
    this.setState({ playState: 'PAUSE' })
  }

  scheduleVideoPlay() {
    this.discardScheduledVideoPlay()
    this.videoPlayTimeout = setTimeout(() => {
      this.setState({ playState: 'PLAY' })
    }, 500)
  }

  discardScheduledVideoPlay() {
    if (this.videoPlayTimeout) {
      clearTimeout(this.videoPlayTimeout)
      this.videoPlayTimeout = null
    }
  }

  onMouseOver() {
    this.timeout = setTimeout(() => {
      this.setState({ hideCursor: true })
    }, 3000)

    this.discardVideoReset()
    this.scheduleVideoPlay()
  }

  onMouseOut() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.setState({ hideCursor: false })

    this.discardScheduledVideoPlay()
    this.pauseVideo()
    this.scheduleVideoReset()
  }

  onMouseMove() {
    if (this.state.hideCursor) {
      this.setState({ hideCursor: false })
    }
  }

  render() {
    const {
      item,
      onAddToFavourites,
      rank,
      onAddToCollections,
      onItemLinkClick,
      onAddToCart,
      muted,
      muteVideo
    } = this.props

    const { playState } = this.state

    let videoLinkStyle
    let overlayStyle

    if (this.state.hideCursor) {
      videoLinkStyle = { cursor: 'none' }
      overlayStyle = { opacity: 0 }
    }

    const videoLength =
      getItemAttribute(item, 'length-video') ||
      getItemAttribute(item, 'after-effects-project-file-length')
    const videoUrl = get(item, 'previews.icon_with_video_preview.video_url')
    const posterUrl = get(
      item,
      'previews.icon_with_video_preview.landscape_url'
    )

    return (
      <div className={styles.container}>
        <div
          className={styles.videoContainer}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onMouseMove={this.onMouseMove}
        >
          <a
            className={styles.videoLink}
            href={`${item.url}?s_rank=${rank}`}
            onClick={onItemLinkClick}
            style={videoLinkStyle}
          >
            <BaseVideoPlayer
              playState={playState}
              muteVideo={muteVideo}
              onVideoProgress={this.handleVideoReportEvent}
              muted={muted}
              preload="none"
              className={styles.video}
              loop
              src={videoUrl}
              poster={posterUrl}
            />
          </a>

          <div className={styles.overlay} style={overlayStyle}>
            <div className={styles.itemActions}>
              <ItemActions
                item={item}
                defaultTheme={false}
                onAddToFavourites={onAddToFavourites}
                onAddToCollections={onAddToCollections}
                onAddToCart={onAddToCart}
              />
            </div>
            <div className={styles.price}>${item.ui.price}</div>
          </div>
        </div>
        {item.trending && <TrendingSash />}
        <div className={styles.meta}>
          <div className={styles.titleContainer}>
            <a
              className={styles.title}
              href={`${item.url}?s_rank=${rank}`}
              onClick={onItemLinkClick}
            >
              {item.name}
            </a>
          </div>
          <div className={styles.duration}>{videoLength}</div>
        </div>
      </div>
    )
  }
}

export default ItemCardGridVideo



// WEBPACK FOOTER //
// ./client/components/itemCard/gridVideo.js